export default __webpack_public_path__ + "static/media/zennya-icon-text.fd397e28.png";